import CollectiveStoryIqos from './CollectiveStoryIqos';
export default CollectiveStoryIqos;
